import { WithPopper } from "components/Popper";

import UserSelector from "./UserSelector";

export default WithPopper(UserSelector);
